






import { Vue, Component, Watch, Prop } from 'nuxt-property-decorator';

const getThemeName = (theme: 'dark' | 'light' | 'auto') => {
  return theme === 'auto' ? 'system' : theme;
};

@Component
export default class BravadoTheme extends Vue {
  @Prop({ type: String }) readonly forcedTheme?: string;

  /**
   * Change the theme on initial load
   */
  @Watch('$auth.user', { immediate: true })
  onThemeChange() {
    if (!process.client) return;

    if (this.$auth.loggedIn && this.$colorMode) {
      window.requestAnimationFrame(() => {
        this.$colorMode.preference = getThemeName(this.$auth.user?.uiTheme!);
      });
    }
  }

  get rootClass() {
    if (!this.forcedTheme) return;
    return `bravado-theme--${this.theme}`;
  }

  get theme() {
    if (this.forcedTheme) return this.forcedTheme;
    return this.$colorMode.value;
  }
}

// Styles for this component included globally to have css variables in the first styles file
